import React from "react";
import glamorous from "glamorous";
import { css } from "glamor";

import Section from "../Section";
import * as Icons from "../FeatureIcons";
import VideoThumbnail from "../../assets/simplified-ui-small-video.png";
// import CornellLogo from "../../assets/logos/cornell.svg";

export const Hero = glamorous(Section)(({ theme, glam = {} }) => {
  let { background, primaryColor, secondaryColor, overhang = false } = glam;
  if (!background && primaryColor && !secondaryColor) {
    secondaryColor = primaryColor;
  } else {
    primaryColor = theme.main.colors.water;
    secondaryColor = theme.main.colors.waterLight;
  }

  if (!background) {
    background = `radial-gradient(ellipse at center, ${primaryColor}, ${secondaryColor})`;
  }

  return {
    background,
    flexDirection: "column",
    padding: `calc(100px + 1.45rem) 1.0875rem ${overhang ? 0 : "calc(100px + 1.45rem)"}`,
    height: "unset",
    marginBottom: overhang ? "-1.45rem" : 0,
    [theme.main.mediaQueries.mobileTablet]: {
      flexDirection: "column",
      marginBottom: 0,
      paddingBottom: "calc(100px + 1.45rem)",
      textAlign: "center"
    }
  };
});

export const HeroTitle = glamorous.h1({
  color: "white",
  textShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
  paddingBottom: "0.45rem"
});

const fadeInAnimations = {
  first: css.keyframes({
    "0%": { opacity: 0 },
    "25%": { opacity: 1 },
    "100%": { opacity: 1 }
  }),
  second: css.keyframes({
    "0%": { opacity: 0 },
    "35%": { opacity: 0 },
    "60%": { opacity: 1 },
    "100%": { opacity: 1 }
  }),
  third: css.keyframes({
    "0%": { opacity: 0 },
    "70%": { opacity: 0 },
    "95%": { opacity: 1 },
    "100%": { opacity: 1 }
  })
};

const slideDown = css.keyframes({
  "0%": { height: 0, opacity: 0 },
  "95%": { height: 0, opacity: 0 },
  "100%": { height: 60, opacity: 1 }
});

const HeroImageContainer = glamorous.div(({ theme }) => ({
  background: "#fefefe",
  borderRadius: 5,
  boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
  height: 270,
  minWidth: 480,
  width: 480,
  [theme.main.mediaQueries.mobileTablet]: {
    display: "none"
  }
}));

const HeroImageTopIcon = glamorous.div(({ color }) => ({
  backgroundColor: color,
  borderRadius: "50%",
  height: 15,
  marginRight: "0.3rem",
  width: 15
}));

const FlowItem = glamorous.div(({ order }) => ({
  textAlign: "center",
  padding: "0.75rem 0",
  width: "33%",
  animation: `${fadeInAnimations[order]} 5s`,
  "& > h5": {
    marginBottom: 0
  }
}));

export const HeroImage = () => {
  const largeIconBle = {width: 75, height: 75};
  const randomIndex = Math.round(Math.random() * 3);
  return (
    <HeroImageContainer>
      <glamorous.Div display="flex" padding="0.75rem 1rem" backgroundColor="#f9f9f9" borderBottom="1px solid #f3f3f3" borderRadius="5px 5px 0 0">
        <HeroImageTopIcon color="#ff5f55" />
        <HeroImageTopIcon color="#ffbd2e" />
        <HeroImageTopIcon color="#27c93f" />
      </glamorous.Div>
      <glamorous.Div display="flex" justifyContent="space-between">
        <FlowItem order="first">
          <Icons.Account css={largeIconBle} />
          <h5>1. Pick a user</h5>
        </FlowItem>
        <FlowItem order="second">
          <Icons.Equipment css={largeIconBle} />
          <h5>2. Select items</h5>
        </FlowItem>
        <FlowItem order="third">
          <Icons.DateRange css={largeIconBle} />
          <h5>3. Book a time</h5>
        </FlowItem>
      </glamorous.Div>
      <glamorous.Div padding="0.25rem 1rem" display="flex" alignItems="center" background="#fafafa" borderTop="1px solid #eee" borderBottom="1px solid #eee" animation={`${slideDown} 5s`}>
        <Icons.CheckMark size={50} color="#32d996" />
        <glamorous.Div display="flex" flexDirection="column" marginLeft="0.5rem">
          <glamorous.H4 marginBottom="0">
            <span>You&apos;re all set!&nbsp;</span>
          </glamorous.H4>
          <glamorous.Small color="#666">
            {
              ["Camera DSLR #5", "Film Holder 20", "Macbook Pro #3", "Doc Space B"][randomIndex]
            } is due back in {
              ["8 hours", "45 minutes", "2 days", "2h 30min"][randomIndex]
            }.
          </glamorous.Small>
        </glamorous.Div>
      </glamorous.Div>
    </HeroImageContainer>
  );
};

export const HeroDescription = glamorous.p(({ theme }) => ({
  fontSize: "24px",
  paddingRight: "2rem",
  [theme.main.mediaQueries.mobile]: {
    paddingRight: 0
  }
}));

export const HeroVideo = glamorous.div(({ theme }) => ({
  background: `#7c7c7c no-repeat url('${VideoThumbnail}') center/contain`,
  border: "8px solid white",
  borderRadius: 2,
  height: 270,
  minWidth: 480,
  width: 480,
  [theme.main.mediaQueries.mobileTablet]: {
    display: "none"
  }
}));



// WEBPACK FOOTER //
// ./src/components/Hero/index.js